import { ofType } from "redux-observable";
import { mergeMap, catchError } from "rxjs/operators";
import { forkJoin } from "rxjs";

import { dispatch } from "../../common/helpers";
import { companyService } from "../../services";

import {
  FETCH_COMPANY_REQUEST,
  FETCH_COMPANY_SUCCESS,
  FETCH_COMPANY_ERROR,
  UPDATE_DEVICE_COMPANY_REQUEST,
  UPDATE_DEVICE_COMPANY_ERROR
} from "./actions";

import { ERROR_NOTIFICATION_REQUEST } from "../notifications/actions";

export const getCompanyList = (action$) => {
  return action$.pipe(
    ofType(FETCH_COMPANY_REQUEST),
    mergeMap(({ payload }) => {
      return companyService.getCompanyList(payload).pipe(
        mergeMap((response) => {
          const companyData = JSON.parse(response);
          const customDataReq = companyData.content.reduce((acc, val) => {
            return [
              ...acc,
              companyService.getCompanyCustomDataById(val.supplierId),
            ];
          }, []);
          return forkJoin(customDataReq).pipe(
            mergeMap((customResp) => {
              companyData.content = companyData.content.map((val, index) => {
                val.customData = JSON.parse(customResp[index]);
                return val;
              })
              return [dispatch(FETCH_COMPANY_SUCCESS, companyData)];
            }),
            catchError((error) => {
              return [dispatch(FETCH_COMPANY_ERROR, error)];
            })
          )
        }),
        catchError((error) => {
          return [dispatch(FETCH_COMPANY_ERROR, error)];
        })
      );
    })
  );
};

export const updateDeviceCompany = (action$) => {
  return action$.pipe(
    ofType(UPDATE_DEVICE_COMPANY_REQUEST),
    mergeMap(({ payload }) =>
      companyService.updateCompany(payload.companyObject).pipe(
        mergeMap(() => {
          return [dispatch(FETCH_COMPANY_REQUEST, payload.pagination)]
        }),
        catchError((error) => [
          dispatch(UPDATE_DEVICE_COMPANY_ERROR, error),
          dispatch(ERROR_NOTIFICATION_REQUEST, {
            response: {
              message: error.response,
            },
          }),
        ])
      )
    )
  );
};
